/*
 * @Author: Bai.Zhiming
 * @Date: 2019-11-25 12:52:26
 * @LastEditTime : 2019-12-24 16:13:32
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\newspaper\left\left.js
 * @Description: 产品管理-报纸左侧导航树
 */
'use strict';
angular.module('productMgrNewspaperLeftModule', []).directive('productMgrNewspaperLeft', [
    '$q',
    'trsHttpService',
    '$location',
    function($q, trsHttpService, $location) {
        return {
            restirct: 'A',
            scope: true,
            replace: false,
            templateUrl: './manageConfig/productManageMent/newspaper/left/left_tpl.html',
            link: function($scope, iElm, iAttrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        isSite: $location.search().paper == undefined ? 0 : $location.search().paper,
                        data: {
                            newspaper: {
                                items: '',
                                list: '',
                            },
                        },
                    };
                    $scope.data = {};
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    requestNewspaperData();
                }

                $scope.$on('changeOrderRank', function() {
                    requestNewspaperData();
                });

                /**
                 * [requestNewspaperData description]获取报纸数据
                 * @return  {[type]}  [return description]
                 */
                function requestNewspaperData() {
                    var params = {
                        serviceid: 'mlf_paperset',
                        methodname: 'queryPagers',
                        CurrPage: 1,
                        PageSize: 500, // 避免不传分页信息的时候默认返回20条
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.status.data.newspaper.list = data.DATA;
                    });
                }
            },
        };
    },
]);
